'use strict';

angular.module('ClinicApp').directive('providerAvailabilitySelector', function(AvailabilityConstants) {
  return {
    templateUrl: '/views/directives/_provider-availability-selector.html',
    scope: {
      provider: '=',
      totalPicked: '=',
      pickState: '=',
      maxPicksPerState: '=',
    },
    link: function(scope) {
      var availabilityStates = AvailabilityConstants.availabilityStates;
      var availabilityStateByPeriodScore = _.indexBy(AvailabilityConstants.availabilityStates, 'periodScore');

      function isClosed(hours, period) {
        // No hours, its closed.
        if (!hours.start && !hours.end) {
          return true;
        }
        var periodHours = AvailabilityConstants.periodMap[period];

        // Calculate overlap between provider hours and period hours.
        var overlap = Math.min(hours.end, periodHours.end) - Math.max(hours.start, periodHours.start);

        // If there is no overlap, it's closed.
        return overlap <= 0;
      }

      function refreshTotalPicked() {
        var totalPicked = {};
        angular.forEach(AvailabilityConstants.availabilityStates, function(value) {
          totalPicked[value.periodScore] = 0;
        });

        for (var day = 0; day < 7; day++) {
          for (var period = 0; period < AvailabilityConstants.periodMap.length; period++) {
            // If it's closed, do not count this block.
            if (isClosed(scope.provider.hours[day], period)) {
              continue;
            }
            var periodScore = scope.provider.availability.periodScores[day][period];
            totalPicked[periodScore]++;
          }
        }

        scope.totalPicked = totalPicked;
      }

      refreshTotalPicked();

      scope.getBlockClass = (day, period) => {
        if (isClosed(scope.provider.hours[day], period)) {
          return availabilityStates.CLOSED.cssClass;
        }
        var periodScore = scope.provider.availability.periodScores[day][period];

        // Only expose the clickable class if the period score matches our
        // current pick state, i.e.:
        // 1) You should see the clickable class on low/neutral, when pick state is low.
        // 2) You should see the clickable class on high/neutral, when pick state is high.
        var cssClasses = [availabilityStateByPeriodScore[periodScore].cssClass];
        if (periodScore == scope.pickState.periodScore) {
          cssClasses.push('clickable');
          cssClasses.push('selected');
        } else if (periodScore == availabilityStates.NEUTRAL.periodScore) {
          cssClasses.push('clickable');
        }

        cssClasses.push(scope.pickState.cssClass + '-active');

        return cssClasses;
      };

      scope.blockPicked = function(_currentWeek, day, period) {
        if (isClosed(scope.provider.hours[day], period)) {
          return;
        }
        var pickedScore = scope.pickState.periodScore;
        var previousScore = scope.provider.availability.periodScores[day][period];

        if (previousScore == availabilityStates.NEUTRAL.periodScore
          && scope.totalPicked[pickedScore] < scope.maxPicksPerState) {
          scope.provider.availability.periodScores[day][period] = pickedScore;
        } else if (previousScore == pickedScore) {
          scope.provider.availability.periodScores[day][period] = availabilityStates.NEUTRAL.periodScore;
        }

        refreshTotalPicked();
      };

    },
  };
});
